import { render, staticRenderFns } from "./ApplicationDocumentsEdit.vue?vue&type=template&id=8fa9a730&"
import script from "./ApplicationDocumentsEdit.vue?vue&type=script&lang=js&"
export * from "./ApplicationDocumentsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports